export class Counter implements ICounter {
    protected _value: number = 0;
    protected _max: number = 1;

    constructor(value: number, max: number) {
        this._value = value;
        this._max = max;
    }

    public reset() {
        this._value = 0;
    }

    public addOne(): void {
        this.add(1);
    }

    public add(value: number): void {
        this._value += value;
    }

    public get value(): number {
        return this._value;
    }

    public get isComplete(): boolean {
        return this._value > this._max;
    }
}

export interface ICounter {
    reset(): void;
    addOne(): void;
    add(value: number): void;
    get value(): number;
    get isComplete(): boolean;
}